// extracted by mini-css-extract-plugin
export default {"container":"Syo7ZIdJSdnBosOS58ip"};